/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import { Modal } from '@zeeve-platform/modal-component';
import Urls from '../../utils/urls';
import CustomLoader from '../common/loader';
import apiBackendInstance from '../../utils/axios';
import { prefixPath } from '../../utils/helpers';
import Plans from './plan';
import SupportedProtocols from './supportedProtocols';

interface ProtocolInfo {
    code: string;
    price: number;
  }

const PurchaseEndpointBody = () => {
  const [selectedPlan, setSelectedPlan] = useState<string>('none');
  const [showLoader, setShowLoader] = useState(true);
  const [protocolData, setProtocolData] = useState([] as ProtocolInfo[]);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);

  const paths = [{ name: 'Dashboard', path: prefixPath('/dashboard') }];
  const getPlanDetails = () => {
    setShowLoader(true);
    apiBackendInstance.get(Urls.getPlans(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data) {
        setProtocolData(response.data.data);
        setDataLoaded(true);
      }
      setShowLoader(false);
    })
      .catch((err) => {
        setShowLoader(false);
        setDataLoaded(false);
        console.error(err);
      });
  };

  useEffect(() => {
    if (!dataLoaded) getPlanDetails();
  }, []);

  return (
    <section className="px-5 col-12 workspace">
      <div className="col-11 mx-auto">
        <div className="col-4" />
        <div className="">
          <div className="col-10">
            <h5 className="mt-2 fw-bold">Select Subscription Options</h5>
          </div>
        </div>
        <div className="row">
          <div className="">
            <Breadcrumb
              prefixLink={paths}
              activeLink="Buy Services - RPC & Blockchain API"
            />
          </div>
          <div className="col-12" style={{ textAlign: 'right' }}>
          <button type="button" className="btn comingSoon shadow" onClick={() => { setShowModal(true); }}>
            Supported RPC Protocol
          </button>

          </div>
        </div>
        <div className="row justify-content-between">
          <CustomLoader showLoader={showLoader} />
          <Plans
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            planData={protocolData}
          />
        </div>
        <Modal
                show={showModal}
                onHide={() => { setShowModal(false); }}
                title="Supported RPC Protocol"
                confirmBtnText="Continue"
                size="lg"
                visibleFooterCloseButton={false}
                visibleFooter={false}
                visibleConfirmBtn={false}
                visibleHeaderCloseIcon
                disableConfirmBtn
                onConfirm={() => { setShowModal(false); }}

        >
            <SupportedProtocols />
        </Modal>
      </div>
    </section>
  );
};
export default PurchaseEndpointBody;
